import React, { useState } from 'react';
import { Button, Box, Typography, Modal, TextField, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { API_URI, END_POINTS } from '../Constants';

import axios from 'axios';
import axiosInstance from '../../Api/Instance';

const InterviewComponent = ({ candidate, setCandidate, open, setOpen, handleInterviewClose }) => {
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [panelists, setPanelists] = useState([{ name: '', email: '' }]);
  const [interviewType, setInterviewType] = useState('');
  const [interviewRound, setInterviewRound] = useState('');
  const [interviewCompany, setInterviewCompany] = useState('');
  const [interviewRole, setInterviewRole] = useState('');
  const [interviewDuration, setInterviewDuration] = useState('');
  const [interviewMode, setInterviewMode] = useState('');
  const [interviewLink, setInterviewLink] = useState('');
  const [interviewFeedback, setInterviewFeedback] = useState('');
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [isEditInterviewDetails, setIsEditInterviewDetails] = useState(false);
  const [interviewId, setInterviewId] = useState('');
  const [loader, setLoader] = useState(false);
  const handleInterviewSubmit = (e) => {
    e.preventDefault();
    let missingFields = [];
    if (!interviewType.trim()) missingFields.push("Interview Type");
    if (!interviewRound.trim()) missingFields.push("Interview Round");
    if (!interviewCompany.trim()) missingFields.push("Interview Company");
    if (!interviewRole.trim()) missingFields.push("Interview Role");
    if (!interviewDuration.trim()) missingFields.push("Interview Duration");
    if (!interviewMode.trim()) missingFields.push("Interview Mode");
    if (!interviewLink.trim()) missingFields.push("Interview Link");
    // Check panelist details
    panelists.forEach((p, index) => {
      if (!p.name.trim()) missingFields.push(`Panelist ${index + 1} Name`);
      if (!p.email.trim()) missingFields.push(`Panelist ${index + 1} Email`);
    });
    const areAllPanelistsValid = panelists.every(
      (n) => n.name.trim() !== '' && n.email.trim() !== ''
    );
    if (missingFields.length > 0 || !areAllPanelistsValid) {
      if (!areAllPanelistsValid) missingFields.push("Panelists must have both name and email.");
      alert("Please fill in all required fields:\n\n" + missingFields.join("\n"));
      return; // Prevent form submission
    }

    setLoader(true)
    if (isEditInterviewDetails) {
      editInterviewDetails()
      setIsEditInterviewDetails(false)
      setLoader(false);
      return;
    }
    else {
      setIsEditInterviewDetails(false)
      const interview_id = candidate.interviewDetails.length > 0 ? `${candidate._id}-${candidate.interviewDetails.length}` : `${candidate._id}-0`
      const interviewPayload = {
        candidate_id: candidate._id,
        interviewDetails: {
          id: interview_id,
          type: interviewType,
          round: interviewRound,
          company: interviewCompany,
          role: interviewRole,
          date: selectedDate,
          duration: interviewDuration,
          mode: interviewMode,
          meetingLink: interviewLink,
          feedback: interviewFeedback,
          interviewerNameAndEmail: panelists
        }
      };

      axiosInstance.post(`/:id/interview`, interviewPayload,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then((res) => {
          setLoader(false);
          setCandidate(res.data.candidate)
          setInterviewType('')
          setInterviewCompany('')
          setInterviewDuration('')
          setInterviewFeedback('')
          setInterviewLink('')
          setInterviewMode('')
          setInterviewRole('')
          setInterviewRound('')
          setInterviewId('')
          setPanelists([{ name: '', email: '' }])
          setSelectedDate(dayjs())
        })
        .catch((err) => {
          console.error(err);
        });
      setOpen(false)
    }
  }
  const handleEditFeedback = (interviewData) => {
    setOpen(true)
    setIsEditInterviewDetails(true)
    if (interviewData.interviewerNameAndEmail && Array.isArray(interviewData.interviewerNameAndEmail)) {
      setPanelists(interviewData.interviewerNameAndEmail);
    }
    setInterviewType(interviewData.type)
    setInterviewCompany(interviewData.company)
    setInterviewDuration(interviewData.duration)
    setInterviewFeedback(interviewData.feedback)
    setInterviewLink(interviewData.meetingLink)
    setInterviewMode(interviewData.mode)
    setInterviewRole(interviewData.role)
    setInterviewRound(interviewData.round)
    setInterviewId(interviewData.id)
    setSelectedDate(dayjs(interviewData.date))
  }

  const editInterviewDetails = async () => {
    const previousPanelists = [...candidate.interviewData?.interviewerNameAndEmail || []];
    const combinedPanelists = [...previousPanelists, ...panelists];
    const validPanelists = combinedPanelists.filter(
      (n) => n && n.name && n.email
    );
    const uniquePanelists = Array.from(
      new Set(validPanelists.map((p) => `${p.name.trim()}-${p.email.trim()}`))
    ).map((id) =>
      validPanelists.find(
        (n) => `${n.name.trim()}-${n.email.trim()}` === id
      )
    );
    const interviewPayload = {
      type: interviewType,
      interviewerNameAndEmail: uniquePanelists,
      round: interviewRound,
      company: interviewCompany,
      role: interviewRole,
      date: selectedDate,
      duration: interviewDuration,
      mode: interviewMode,
      meetingLink: interviewLink,
      feedback: interviewFeedback
    };
    try {
      // const response = await axios.post(
      //   `${API_URI}/interview/${candidate._id}/${interviewId}`,
      //   interviewPayload,
      //   { headers: { 'Content-Type': 'application/json' } }
      // );
      axiosInstance.post(`/${candidate._id}/interview/${interviewId}`, interviewPayload,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then((res) => {
          setLoader(false);
          setCandidate(res.data.candidate);
          setOpen(false)
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error('Error updating feedback:', error);
      throw error;
    }
  }
  const addPanelist = () => {
    setPanelists([...panelists, { name: '', email: '' }]);
  };
  const handlePanelistChange = (index, value) => {
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
    const match = value.match(emailRegex);
    const email = match ? match[0].trim() : '';
    const name = match ? value.replace(match[0], '').replace(',', '').trim() : value.trim();
    const updated = [...panelists];
    updated[index] = { name, email };
    setPanelists(updated);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    maxHeight: '90vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  };
  return (
    <div>
      <div>
        {candidate?.interviewDetails && candidate.interviewDetails.length > 0 ? (
          <div className="flex flex-wrap gap-4 overflow-x-auto h-[325px]  ">
            {candidate?.interviewDetails.map((interview, index) => (
              <div key={index} className="border rounded-lg p-4 w-full w-[250px] shadow-lg bg-gray-50 ">
                <p><span className="font-bold">Type:</span> {interview.type}</p>
                <p><span className="font-bold">Interview Round:</span> {interview.round}</p>
                {interview.interviewerNameAndEmail.map((interviewer, i) => <p><span className='font-bold'>Panelist-{i + 1}: </span>{interviewer.name.toUpperCase()}, <span className='font-bold text-indigo-700 cursor-pointer'>{interviewer.email}</span></p>)}
                <p><span className="font-bold">Company:</span> {interview.company}</p>
                <p><span className="font-bold">Role:</span> {interview.role}</p>
                <p><span className="font-bold">Date:</span>{dayjs(interview.date).format('DD-MM-YYYY')}</p>
                <p><span className="font-bold">Duration:</span> {interview.duration}</p>
                <p><span className="font-bold">Mode:</span> {interview.mode}</p>
                <p><span className="font-bold">Meeting Link:</span> <a href={interview.meetingLink} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">{interview.meetingLink}</a></p>
                <p><span className="font-bold">Feedback:</span> {interview.feedback}</p>
                <p className='underline text-blue-600 font-bold cursor-pointer' onClick={() => handleEditFeedback(interview)}>Edit Details</p>
              </div>
            ))}
          </div>
        ) : (
          <p>No Interview Details Available</p>
        )}
      </div>

      {/* Modal for adding/editing interview */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style} className="scrollbar-thin scrollbar-rounded overflow-y-scroll">
          <Typography variant="h6" textAlign="center" mb={2}>
            Interview Details
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <Box sx={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField label="Interview Type" value={interviewType} onChange={(e) => setInterviewType(e.target.value)} fullWidth />
              <TextField label="Interview Round" value={interviewRound} onChange={(e) => setInterviewRound(e.target.value)} fullWidth />
              <TextField label="Interviewing for company" value={interviewCompany} onChange={(e) => setInterviewCompany(e.target.value)} fullWidth />
              <TextField label="Interviewing for role" value={interviewRole} onChange={(e) => setInterviewRole(e.target.value)} fullWidth />
            </Box>
            <Box sx={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField label="Duration of interview" value={interviewDuration} onChange={(e) => setInterviewDuration(e.target.value)} fullWidth />
              <TextField label="Interview Mode" value={interviewMode} onChange={(e) => setInterviewMode(e.target.value)} fullWidth />

              <TextField label="Meeting Link" value={interviewLink} onChange={(e) => setInterviewLink(e.target.value)} fullWidth />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Interview Date" value={selectedDate} onChange={(newValue) => setSelectedDate(newValue)} slotProps={{ textField: { fullWidth: true } }} />
              </LocalizationProvider>
            </Box>
            <Box sx={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', gap: 2 }}>
              {panelists.map((p, index) => (
                <div key={index} className="flex items-center">
                  <TextField
                    type="text"
                    label='Panelist Details'
                    value={`${p.name}${p.name && p.email ? ', ' : ''}${p.email}`}
                    onChange={(e) => handlePanelistChange(index, e.target.value)}
                    className="flex-1 p-2 border border-gray-300 rounded"
                    placeholder={`Name, Email`}
                  />
                  {index === panelists.length - 1 && (
                    <Tooltip title="Add More Panelists"><AddIcon className='cursor-pointer'
                      onClick={addPanelist}
                    /></Tooltip>)}
                </div>
              ))}
              <TextField label="Interview Feedback" value={interviewFeedback} onChange={(e) => setInterviewFeedback(e.target.value)} fullWidth />
            </Box>
          </Box>
          <Box mt={3} display="flex" gap={2}>
            <Button variant="contained" fullWidth onClick={handleInterviewSubmit}>
              Submit
            </Button>
            <Button variant="outlined" fullWidth onClick={handleInterviewClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default InterviewComponent;